import { render, staticRenderFns } from "./Activeintegrations.vue?vue&type=template&id=8e05ac02&scoped=true&"
import script from "./Activeintegrations.vue?vue&type=script&lang=js&"
export * from "./Activeintegrations.vue?vue&type=script&lang=js&"
import style0 from "./Activeintegrations.vue?vue&type=style&index=0&id=8e05ac02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e05ac02",
  null
  
)

export default component.exports